import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiEndpoints} from "../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-menu-list-network-server-groups',
  templateUrl: './menu-list-network-server-groups.component.html',
})
export class MenuListNetworkServerGroupsComponent implements OnInit {

  private apiUrl = ApiEndpoints.GET_ALL_NETWORK_SERVER_GROUPS;
  list: any[];

  constructor(private http: HttpClient) {
    this.getServers();
    this.getData();
  }

  getData() {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers };
    return this.http.post<any>(this.apiUrl, "", options);
  }

  getServers() {
    this.getData().subscribe(list => {
      this.list = list;
    });
  }

  ngOnInit() {
  }

}
